








import { Component, Vue } from "vue-property-decorator";
import Generico from "@/components/Comuna/Generico.vue";

@Component({
  components: {
    Generico
  }
})
export default class GenericoView extends Vue {}
